import { render } from "./JoinPublicationForgotPassword.vue.js?vue&type=template&id=04308e60!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationForgotPassword.vue?vue&type=template&id=04308e60"
import script from "./JoinPublicationForgotPassword.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationForgotPassword.vue?vue&type=script&lang=js"
export * from "./JoinPublicationForgotPassword.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04308e60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04308e60', __exports__)) {
    api.reload('04308e60', __exports__)
  }
  
  module.hot.accept("./JoinPublicationForgotPassword.vue.js?vue&type=template&id=04308e60!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationForgotPassword.vue?vue&type=template&id=04308e60", () => {
    api.rerender('04308e60', render)
  })

}


export default __exports__